import { Component, EventEmitter, Output } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-menu-services[closePopover]',
    templateUrl: './menu-services.component.html',
    styleUrls: ['./menu-services.component.scss'],
})
export class MenuServicesComponent {
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    readonly geneticMonitoringUrl = environment.geneticMonitoringUrl;
    readonly microbiomeUrl = environment.microbiomeUrl;
    readonly colonyUrl = environment.colonyUrl;
    readonly tagCenterUrl = 'https://tagcenter.info/';

    close(): void {
        this.closePopover.emit();
    }
}
